export const defaultLoginLayout = {
  backgroundImageClassName: "absolute right-0 h-screen w-7/10",
  clientLogoClassName: "-mt-15 mb-10",
  formClassName: "absolute left-30 top-1/2 w-102 -translate-y-1/2",
  name: "default",
  overlayClassName: null,
  particlesClassName: null,
  sectionClassName: "",
};

export const glassLoginLayout = {
  backgroundImageClassName: "absolute right-0 h-screen w-full object-cover",
  clientLogoClassName: "mb-10 mt-0",
  formClassName:
    "absolute left-30 top-1/2 z-login_form w-102 -translate-y-1/2 rounded-ds-0-75x border border-ds-subtle bg-lds-surface-bright p-8 !opacity-[85%] shadow-elevation100 backdrop-blur-md",
  name: "glass",
  overlayClassName:
    "pointer-events-none absolute inset-y-0 left-0 z-login_overlay w-full bg-lds-overlay-light backdrop-blur-[3px]",
  particlesClassName: "absolute inset-0 z-login_particles",
  sectionClassName: "relative min-h-screen overflow-hidden",
};
